import { Grid, FormControl, TextField } from "@mui/material";
import { Dimension } from "../../TypesAndConstants/types";
import makeStyles from "@mui/styles/makeStyles";
import { getAuthAPI } from "../../../services/api";
import { logSave, logDownload } from "../../../services/GAService";
import React, { memo, useContext, useState, useEffect } from "react";
import "../../../App.css";
import { Context } from "../../Context/context";
import { useSizingContext } from "../../Context/SizingContext";
import { baseStyle } from "../../theme";
import { ColorTheme } from "../../TypesAndConstants/const";
import { MenuActions } from "../../TypesAndConstants/types";
import SimpleDialog from "./SimpleDialog";
import { THREE_INST } from "../SketchUtilities/Three/threeSingleton";
import { NavBar } from "./BrushMenus/TopMenu/NavBar";
import ColorSideBarModal from "./Cards/ColorSelectSideBar/ColorSideBarModal";
import { ToolbarContainer } from "./ToolbarContainer";
import ReactNativeMessageHandler from "../ReactNativeMessageHandler";
import { MenuContext } from "./BrushMenus/TopMenu/TopMenuContext";
import { getToken } from "../../../services/authService";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useAuth } from "../../Context/AuthContext";
import LoginModal from "./LoginModal";
import RegistrationModal from "./RegistrationModal";

const drawerWidth = 200;
const useStyles = makeStyles((theme) => ({
  loadingInactive: {
    display: "none",
  },
  loadingActive: {
    position: "fixed",
    top: "0px",
    left: "0px",
    backgroundColor: "rgba(255,255,255,0.8)",
    width: "100%",
    height: "100%",
    zIndex: 5,
    opacyt: 1,
    pointerEvents: "all",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  drawer: {
    width: drawerWidth,
    elevation: 4,
    flexShrink: 0,
    topRightBorderRadius: "150px",
  },
  drawerPaper: {
    overflowX: "hidden",
    minWidth: "150px",
    fontSize: "20px",
    height: "fit-content",
    maxHeight: "75%",
    marginTop: "15vh",
    padding: "5px",
    width: "15%",
  },
  brushHandles: {
    position: "fixed",
    zIndex: 100000,
    borderRadius: "20px",
    padding: "5px",
    border: `2px solid ${ColorTheme.primaryText}`,
    background: ColorTheme.secondaryBackground,
    top: "17h",
  },
  drawerPaperTablet: {
    overflowX: "hidden",
    fontSize: "20px",
    height: "fit-content",
    maxHeight: "84vh",
    overFlow: "auto",
    marginTop: "15vh",
    padding: "5px",
  },
  colorBar: {
    fontFamily: "'amatic', cursive",
    width: "10%",
    minWidth: "150px",
    fontSize: "20px",
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "30px",
    height: "fit-content",
    marginTop: "20vh",
  },
  items: {
    fontFamily: "'amatic', cursive",
    fontSize: "28px",
  },
  list: {},
  newCanvas: {
    background: "white",
    cursor: "pointer",
    padding: "5px",
    borderTop: "0px",
    borderLeft: "0px",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderBottomRightRadius: "5px",
    display: "flex",
    position: "absolute",
    top: "0%",
    left: "0",
    zIndex: 2000,
    backgroundColor: ColorTheme.secondaryBackground,
    fontSize: "40px",
  },
  mobileHistoryContainer: {
    display: "none",
  },
  historyItem: {
    display: "flex",
    height: "44px",
    margin: "0 auto",
    marginTop: "3%",
    fontSize: "25px",
    textAlign: "center",
    fontFamily: "'amatic', cursive",
  },
  historyImage: {
    height: "50px",
  },
}));

export const navItems: MenuActions[] = [
  "pen",
  "spring",
  "wipe",
  "growshrink",
  "shape",
];

const Controls = function (props: any) {
  const {
    state: {
      currentActiveMenu,
      colorBarIsCollapsed,
      brushbarIsCollapsed,
      userSessionData,
      dimensions,
    },
    dispatch,
  } = useContext(Context);
  const classes = useStyles();
  const {
    state: { screenWidth, screenHeight, isPortrait, isMobile },
  } = useSizingContext();
  const { state: localState } = useContext(MenuContext);
  const [isPublic, setIsPublic] = useState<boolean>(true);
  const [processingStyle, setProcessingStyle] = useState<any>(
    classes.loadingInactive,
  );
  const [isSmallPreview, setSmallPreview] = useState<boolean>(false);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [storedImage, setStoredImage] = useState<string | undefined>();
  const [imageTitle, setTitle] = useState<string>("");
  const [openSpeedDial, setOpenSpeedDial] = useState<boolean>(false);
  const [loginModalOpen, setLoginModalOpen] = useState<boolean>(false);
  const [registrationModalOpen, setRegistrationModalOpen] =
    useState<boolean>(false);
  const [pendingSaveAction, setPendingSaveAction] = useState<
    (() => void) | null
  >(null);
  const auth = useAuth();
  const three = THREE_INST.getInst();
  const baseStyles = baseStyle({});

  const closeCard = () => {
    dispatch({ type: "set_active_menu", value: "none" });
  };

  const onNewCanvas = () => {
    dispatch({ type: "set_active_menu", value: "new" });
  };

  const undo = () => {
    dispatch({ type: "undo", value: undefined });
  };

  /* eslint react-hooks/exhaustive-deps: off */
  const storeImageForSaveOpenModal = React.useCallback(() => {
    setStoredImage(three.obj.getDownloadImage());
    setModalOpen(true);
  }, []);

  // useInterval(() => {
  //   setHistoryCounter(three.obj.backgroundImages.length);
  // }, 500);

  const onSave = (
    title: string | null,
    tag: string | null,
    isPublic: boolean,
  ) => {
    console.info("drawing off ");
    three.obj.isUploading = true; /* this prevents from drawing */
    setProcessingStyle(classes.loadingActive);
    const image = three.obj.getDownloadImage();
    if (image) {
      postImage(title, tag, isPublic, () => {
        three.obj.isUploading = true; /* this prevents from drawing */
        setProcessingStyle(classes.loadingActive);

        setTimeout(function () {
          window.location.replace("/mygallery");
        }, 0);
      });
    }
  };
  const postImage = async (
    title: string | null,
    tag: null | string,
    isPublic: boolean,
    cb: (res: any) => void,
  ) => {
    const formData = new FormData();
    let token = getToken();
    if (token) {
      formData.append("file_in_base64", three.obj.getDownloadImage() as string);
      formData.append(
        "title",
        title || (("My Art " + new Date().toString()) as string),
      );
      formData.append("is_public", isPublic ? "1" : "0");
      if (tag) {
        formData.append("tag", tag);
      }
      const url = `arts/upload`;
      const axiosInstance = getAuthAPI();
      axiosInstance.post(url, formData).then((res) => {
        cb(res);
      });
    } else {
      alert("token isn't available");
    }
  };

  const getFileName = (): string | null => {
    const fileName =
      (document.querySelector("#standard-basic") as HTMLInputElement)?.value ??
      null;
    return fileName;
  };

  const getAddTag = (): boolean | null => {
    return (
      (document.querySelector("#standard-basic-check") as HTMLInputElement)
        ?.checked ?? false
    );
  };

  const getIsPublic = (): boolean => {
    return (
      (document.querySelector("#standard-public-check") as HTMLInputElement)
        ?.checked ?? false
    );
  };

  const downloadImage = (fileName: string | null = null) => {
    if (storedImage) {
      if (window.isMobileSplash && window.ReactNativeWebView) {
        ReactNativeMessageHandler.postMessage(
          {
            image: three.obj.getDownloadImage(),
            title: imageTitle,
          },
          "downloadImage",
        );

        return;
      }
      var link = document.createElement("a");
      link.download = `${fileName ?? imageTitle}.png`;
      link.href = storedImage;
      link.click();
    }
  };

  const saveImageDialog = () => {
    const buttons = isDownload
      ? {
          actionCB: () => {
            let title = getFileName();
            downloadImage(title);
            logDownload(auth.state.isLoggedIn);
            setTitle("");
            setModalOpen(false);
            setOpenSpeedDial(false);
            closeCard();
          },
          actionTitle: "Download",
        }
      : {
          actionCB: () => {
            let title = getFileName();
            let tag = getAddTag() === true ? userSessionData.default_tag : null;
            let isPublic = getIsPublic();
            setModalOpen(false);
            setOpenSpeedDial(false);
            logSave(isPublic ? "Public" : "Private");
            onSave(title, tag, isPublic);
          },
          actionTitle: "Save To Gallery!",
        };

    return SimpleDialog({
      open: isModalOpen,
      title: "Your art needs a title!",
      content: saveImageDialogContent(),
      actionTitle: buttons.actionTitle,
      actionCB: buttons.actionCB,
      handleClose: () => {
        setModalOpen(false);
        setTitle("");
        setOpenSpeedDial(false);
      },
    });
  };

  const saveImageDialogContent = () => {
    return (
      <Grid container spacing={3} style={{ marginTop: "2px" }}>
        <Grid item xs={12}>
          <FormControl>
            <TextField
              autoFocus={true}
              id="standard-basic"
              onChange={(event) => {
                setTitle((event.target as any).value);
              }}
              label="Title"
              value={imageTitle}
              style={{ margin: "10px" }}
            />
          </FormControl>
        </Grid>
        {!isDownload && (
          <>
            <Grid item xs={12} key="2">
              <FormControlLabel
                control={
                  <Checkbox
                    id="standard-public-check"
                    checked={isPublic}
                    onChange={(e) => {
                      setIsPublic(e.target.checked);
                    }}
                    name="addToSharedGallery"
                    color="primary" // You can change the color as needed
                  />
                }
                label={`Add to Shared Gallery (Make it Public)`}
              />
            </Grid>
          </>
        )}
      </Grid>
    );
  };

  /* this function resize preview size if overwraps with canvas */
  function updatePreviewSize(
    dimensions: Dimension,
    screenWidth: number,
    screenHeight: number,
  ) {
    const normalPreviewSize = 100;
    const menubarHeight = 50;
    let rotated = isMobile && isPortrait;
    var width = rotated ? dimensions.height : dimensions.width;
    var height = rotated ? dimensions.width : dimensions.height;
    var normal = true;
    if (screenHeight - height < menubarHeight + normalPreviewSize) {
      normal = false;
    } else if ((screenWidth - width) / 2 < normalPreviewSize) {
      normal = false;
    }
    console.info("normal = " + normal);
    setSmallPreview(!normal);
  }

  useEffect(() => {
    three.obj.mountPreview();
    three.obj.setPreviewTexture(three.obj.initialBrush);
    three.obj.setAlphaTexture(three.obj.initialBrush);
    dispatch({ type: "set_active_brush", value: three.obj.initialBrush });
  }, []);

  useEffect(() => {
    if (!isModalOpen) {
      setProcessingStyle(classes.loadingInactive);
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (brushbarIsCollapsed) {
      console.info("Preview: main");
      three.obj.mountPreview();
    } else {
      console.info("Preview: modal");
      three.obj.mountPreviewMobile();
    }
  }, [brushbarIsCollapsed]);

  useEffect(() => {
    updatePreviewSize(dimensions, screenWidth, screenHeight);
  }, [dimensions, screenWidth, screenHeight]);

  return (
    <>
      <div
        id={"previewCanvas"}
        className={` ${baseStyles.previewCanvasContainer} ${baseStyles.background}`}
        style={{
          display: localState.displayPreview ? "block" : "none",
          position: "fixed",
          width: "100px",
          height: "100px",
          background: "white",
          top: "10px",
          right: "10px",
          transformOrigin: "top right",
          transform: isSmallPreview ? "scale(0.5)" : "scale(1.0)",
        }}
      />
      {saveImageDialog()}
      <ColorSideBarModal display={"inherit"} />
      {NavBar({
        openBrush: () => {
          three.obj.isMobileMenuOpen =
            brushbarIsCollapsed || colorBarIsCollapsed;
          setTimeout(() => {
            three.obj.mountPreviewMobile();
          }, 1);
          dispatch({
            type: "set_brushbar_collapsed",
            value: !brushbarIsCollapsed,
          });
        },
        openColors: () => {
          three.obj.isMobileMenuOpen =
            brushbarIsCollapsed || colorBarIsCollapsed;
          dispatch({
            type: "set_colorbar_collapsed",
            value: !colorBarIsCollapsed,
          });
        },
        undo: () => {
          undo();
        },
        redo: () => {},
        downloadImage: () => {
          setIsDownload(true);
          storeImageForSaveOpenModal();
          setOpenSpeedDial(false);
        },
        saveImage: () => {
          if (auth.state.isLoggedIn) {
            setIsDownload(false);
            storeImageForSaveOpenModal();
          } else {
            // Store the save action to execute after login
            setPendingSaveAction(() => () => {
              setIsDownload(false);
              storeImageForSaveOpenModal();
            });
            setLoginModalOpen(true);
          }
          setOpenSpeedDial(false);
        },
        newCanvas: () => {
          onNewCanvas();
        },
        setOpenSpeedDial: (val) => {
          console.info("set open speed dial");
          setOpenSpeedDial(val);
        },
        openSpeedDial: openSpeedDial,
        onLogin: () => {
          setLoginModalOpen(true);
        },
        onLogout: () => {
          // Clear auth state
          auth.dispatch({
            type: "set_login",
            value: { isLoggedIn: false },
          });
          // Clear any stored tokens
          localStorage.removeItem("ATToken");
        },
        onRegister: () => {
          setRegistrationModalOpen(true);
        },
      })}
      <ToolbarContainer
        activeMenu={currentActiveMenu}
        closeCard={closeCard}
        dispatch={dispatch}
      />

      <div className={processingStyle}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="300px"
          height="300px"
          viewBox="0 0 200 200"
        >
          <circle cx="60" cy="100" fill="#F652A0">
            <animate
              attributeName="r"
              values="0;5;0"
              dur="1.2s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="100" cy="100" fill="#F652A0">
            <animate
              attributeName="r"
              values="0;5;0"
              dur="1.2s"
              begin="0.4s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="140" cy="100" fill="#F652A0">
            <animate
              attributeName="r"
              values="0;5;0"
              dur="1.2s"
              begin="0.8s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>

      <LoginModal
        open={loginModalOpen}
        onClose={() => {
          setLoginModalOpen(false);
          setPendingSaveAction(null);
        }}
        onLoginSuccess={() => {
          // Execute the pending save action after successful login
          if (pendingSaveAction) {
            pendingSaveAction();
            setPendingSaveAction(null);
          }
        }}
        onSwitchToRegister={() => {
          setLoginModalOpen(false);
          setRegistrationModalOpen(true);
        }}
      />

      <RegistrationModal
        open={registrationModalOpen}
        onClose={() => {
          setRegistrationModalOpen(false);
          setPendingSaveAction(null);
        }}
        onRegistrationSuccess={() => {
          // Registration successful, user needs to confirm email before login
          console.log("Registration successful");
        }}
        onSwitchToLogin={() => {
          setRegistrationModalOpen(false);
          setLoginModalOpen(true);
        }}
      />
    </>
  );
};

export default memo(Controls);
